<div class="card customCard" >
    <p-table responsiveLayout="stack" [value]="messagess"  breakpoint="1050px">
        <ng-template pTemplate="caption" class="captionCustom">
            <span class="csf5">Recent messages </span><span class="headerButtons"><button pButton pRipple type="button" label="Send message" icon="pi pi-send" class="p-button-raised p-button-success" (click)="redirectChat()"></button> <button pButton pRipple type="button" icon="pi pi-comment" label="Connect number" class="p-button-raised mL-3" (click)="redirectConnect()"></button></span>
            <span class="headerButtons1"><button pButton pRipple type="button" icon="pi pi-send" class="p-button-raised p-button-success p-button-rounded" (click)="redirectChat()"></button> <button pButton pRipple type="button" icon="pi pi-comment" class="p-button-raised p-button-rounded mL-3" (click)="redirectConnect()"></button></span>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th></th>
                <th class="tableHeading">TARGET</th>
                <th class="tableHeading">DEVICE</th>
                <th class="tableHeading">STATUS</th>
                <th class="tableHeading">CREATED</th>
                <th class="tableHeading">SCHEDULED</th>
                <th class="tableHeading">TYPE</th>
                <th class="tableHeading">PRIORITY</th>
                <th class="tableHeading">MESSAGE</th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-messages let-columns="columns">
            <tr>
                <td><i class="pi pi-eye"></i></td>
                <td><span class="p-column-title tableHeading">Target</span><div><i class="pi pi-user mt-2"></i><span class="customFont1">  {{messages.targetNumber}}</span></div></td>
                <td><span class="p-column-title tableHeading">Device</span><div class="pT-12"><h5 class="customFont1">
                    <img src="https://img.icons8.com/emoji/48/000000/green-circle-emoji.png" width="11"/>
                    {{messages.deviceName}}</h5></div></td>
                <td><span class="p-column-title tableHeading">Status</span><div class="pT-12" *ngIf="messages.status === 'sent'"><h5 class="customFont2"><img src="https://img.icons8.com/emoji/48/000000/green-circle-emoji.png" width="11"/> {{messages.status}}</h5></div>
                    <div class="pT-12"  *ngIf="messages.status !== 'sent'"><h5 class="customFont2"><img src="https://img.icons8.com/emoji/48/000000/red-circle-emoji.png" width="11"/>{{messages.status}}</h5></div></td>
                <td><span class="p-column-title tableHeading">Created</span><div class="pT-12" ><h5 class="customFont2">{{messages.created}}</h5></div></td>
                <td><span class="p-column-title tableHeading">Scheduled</span><div class="pT-12"><h5 class="customFont2">{{messages.scheduled}}</h5></div></td>
                <td><span class="p-column-title tableHeading">Type</span><div class="pT-12"><h5 class="customFont2">{{messages.type}}</h5></div></td>
                <td><span class="p-column-title tableHeading">Priority</span><div><p-rating [ngModel]="messages.priority" [readonly]="true" [cancel]="false"></p-rating> </div></td>
                <td>
                    <span class="p-column-title tableHeading">Message</span>
                    <div class="pT-12"><h5 class="customFont1">{{messages.message}}</h5></div>
                </td>
                <td>
                    <span>
                        <button type="button" pButton icon="pi pi-ellipsis-v" (click)="menu.toggle($event)" class="p-button-text btnCust">
                            <p-menu #menu [popup]="true" [model]="items"></p-menu>
                        </button>
                        
                </span>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
